import { useEffect, useRef } from 'react'
import styles from './Grain.module.css'
import { getGrainTile, GRAIN_TILE_CSS_PX } from './grainTile'

/**
 * A barely-there paper grain over the whole page (`--z-grain`, `pointer-events: none`).
 * The tile is generated once on a canvas (no network, no animation), so after the first
 * paint it costs nothing: one static, composited layer.
 */
export function Grain() {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = ref.current
    const tile = getGrainTile()
    if (!element || !tile) return
    element.style.backgroundImage = `url(${tile})`
    element.style.backgroundSize = `${GRAIN_TILE_CSS_PX}px ${GRAIN_TILE_CSS_PX}px`
  }, [])

  return <div ref={ref} className={styles.grain} aria-hidden="true" />
}
